function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7099 3.5H8.95679C8.63578 3.5 8.47528 3.5 8.33996 3.51258C6.8359 3.65236 5.64343 4.91912 5.51184 6.51688C5.5 6.66062 5.5 6.83113 5.5 7.17213V22.6728C5.5 23.5889 6.59792 23.9777 7.11538 23.2448C7.47436 22.7363 8.19231 22.7363 8.55128 23.2448L9 23.8803C9.58333 24.7066 10.75 24.7066 11.3333 23.8803C11.9167 23.0541 13.0833 23.0541 13.6667 23.8803C14.25 24.7066 15.4167 24.7066 16 23.8803C16.5833 23.0541 17.75 23.0541 18.3333 23.8803C18.9167 24.7066 20.0833 24.7066 20.6667 23.8803L21.1154 23.2448C21.4744 22.7363 22.1923 22.7363 22.5513 23.2448C23.0688 23.9777 24.1667 23.5889 24.1667 22.6728V7.17213C24.1667 6.83113 24.1667 6.66062 24.1548 6.51688C24.0232 4.91912 22.8308 3.65236 21.3267 3.51258C21.1914 3.5 21.0309 3.5 20.7099 3.5Z",
  stroke: "#6A6F73",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8333 17.8886C16.122 17.8886 17.1667 17.018 17.1667 15.9441C17.1667 14.8702 16.122 13.9997 14.8333 13.9997C13.5447 13.9997 12.5 13.1291 12.5 12.0552C12.5 10.9813 13.5447 10.1108 14.8333 10.1108M14.8333 17.8886C13.5447 17.8886 12.5 17.018 12.5 15.9441M14.8333 17.8886V18.6663M14.8333 9.33301V10.1108M14.8333 10.1108C16.122 10.1108 17.1667 10.9813 17.1667 12.0552",
  stroke: "#6A6F73",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgTransactionHistory = function SvgTransactionHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransactionHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transaction-history.10000cdf.svg";
export { ForwardRef as ReactComponent };